import React from 'react'
import tw, { styled } from 'twin.macro'
import Footer from '../components/elements/Footer'
import Navbar from '../components/elements/Navbar'
import components from '../content/common'
import { useBreakpoint } from '@hooks/useBreakpoint'

export const Section = styled.section`
  ${tw`w-full bg-radler pb-20 pt-20 lg:pb-40 lg:pt-56 overflow-hidden`}

  p {
    ${tw`text-white pt-5 text-15px lg:text-18px font-roboto`}
    b {
      ${tw``}
    }
  }

  a {
    ${tw`text-gelb`}
    &:hover {
      filter: drop-shadow(1px 2px 0.75rem rgba(247, 211, 3, 1));
    }
  }
`

export const Headline = tw.h2`text-32px md:text-5xl lg:text-75pxv2 text-white my-10`

export const Subtitle = tw.h3`font-DIN text-white text-left md:text-[32px] leading-[38px] text-2xl max-w-[300px] lg:p-0 pt-5`

export const ListWrap = tw.div`pt-5`
export const List = tw.ul`list-disc mx-5 lg:mx-10`
export const ListItem = tw.li`pb-2 lg:text-18px text-white`

const list = [
  'Kommunikation mit Ihnen zu Produkten, Dienstleistungen, z.B. um Ihre Anfragen zu bearbeiten und eine Bestellbestätigung zu versenden;',
  'Planung, Durchführung und Verwaltung der (vertraglichen) Geschäftsbeziehung zwischen uns und Ihnen, z.B. um die Bestellung von Produkten und Dienstleistungen abzuwickeln, Zahlungen einzuziehen, zu Zwecken der Buchhaltung, Abrechnung und des Forderungseinzugs und um Lieferungen oder Bearbeitung von Reklamationen durchzuführen, sowie für unseren Kundendienst und für Rückfragen',
  'Durchführung von Kundenbefragungen, Marketingkampagnen, Marktanalysen, Gewinnspielen, Wettbewerben oder ähnlichen Aktionen und Events',
  'Bereitstellung eines Newsletters und Werbung bzgl. neuer Produkte',
  'Erstellung pseudonymisierter Nutzungsprofile zum Zwecke der Werbung, zur Marktforschung und zur Verbesserung unserer Dienste',
  'Aufrechterhaltung und Schutz der Sicherheit unserer Produkte und Dienstleistungen sowie unserer Webseiten durch Verhinderung und Aufdeckung von Sicherheitsrisiken, betrügerischem Vorgehen oder anderen kriminellen oder mit Schädigungsabsicht vorgenommenen Handlungen;',
  'Einhaltung rechtlicher Anforderungen (z.B. von steuer- und handelsrechtlichen Aufbewahrungspflichten) bzw. bestehender Pflichten zur Durchführung von Compliance Screenings (etwa Sanktionlistenprüfung und um Wirtschaftskriminalität oder Geldwäsche vorzubeugen)',
  'Beilegung von Rechtsstreitigkeiten, Durchsetzung bestehender Verträge und zur Geltendmachung, Ausübung und Verteidigung von Rechtsansprüchen.',
]

const linkList = [
  {
    name: 'Mozilla Firefox',
    href: 'https://support.mozilla.org/de/kb/cookies',
  },
  {
    name: 'Internet Explorer',
    href: 'https://support.microsoft.com/de-de/topic/löschen-von-cookiedateien-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc',
  },
  {
    name: 'Google Chrome',
    href: 'https://support.google.com/chrome/answer/95647?hl=de&co=GENIE.Platform%3DDesktop',
  },
  {
    name: 'Safari',
    href: 'https://support.apple.com/de-de/guide/safari/sfri11471/mac',
  },
]

const list2 = [
  'die IP-Adresse des Nutzers, gekürzt um die letzten zwei Bytes (anonymisiert)',
  'die aufgerufene Unterseite und Zeitpunkt des Aufrufs',
  'die Seite, von der der Nutzer auf unsere Webseite gelangt ist (Referrer)',
  'welcher Browser mit welchen Plugins, welches Betriebssystem und welche Bildschirmauflösung genutzt wird',
  'die Verweildauer auf der Websit',
  'die Seiten, die von der aufgerufenen Unterseite aus angesteuert werden',
]

const list3 = [
  'Sie können die Ablage von Cookies in ihrem Browser ganz unterbinden. Das führt allerdings dazu, dass Sie möglicherweise manche Funktionen unserer Website nicht mehr nutzen können, die zwingend eine Identifizierung voraussetzen (Warenkorb, Bestellungen, persönliche Einstellungen o.ä.)',
  'Sie können die Einstellung „Do-not-Track“ in Ihrem Browser aktivieren. Unser Matomo-System ist so konfiguriert, dass es diese Einstellung respektiert.',
  'Sie können mit einem Mausklick unten ein so genanntes Opt-Out-Cookie anlegen, das zwei Jahre Gültigkeit hat. Es hat zur Folge, dass Matomo Ihre weiteren Besuche nicht registrieren wird. Beachten Sie allerdings, dass das Opt-Out-Cookie gelöscht wird, wenn Sie alle Cookies löschen.',
]

const IndexPage = () => {
  const { isMobile } = useBreakpoint()
  return (
    <>
      <Navbar content={components.navbar} />
      <Section>
        <div tw="max-w-screen-2xl mx-auto px-3 sm:px-7">
          <Headline>Datenschutzerklärung</Headline>
          <Subtitle>Datenschutzerklärung</Subtitle>
          <p>
            Datenschutz ist ein wichtiges Anliegen der Privatbrauerei ERDINGER
            Weißbräu Werner Brombach GmbH, Lange Zeile 1 + 3, 85435 Erding.
            Daher erfolgt die Verarbeitung der Daten unserer Kunden
            ausschließlich unter Beachtung der geltenden datenschutzrechtlichen
            Vorschriften (z.B. DSGVO, BDSG-neu).
          </p>
          <p>
            Wir erheben und verarbeiten personenbezogene Daten, wenn Sie uns
            diese Daten zur Verfügung stellen (z.B. durch Teilnahme an
            Gewinnspielaktionen oder zur Bestellung des Newsletters) und wir
            aufgrund einer von Ihnen erteilten Einwilligung oder auf der
            Grundlage einer gesetzlichen Vorschrift zu deren Erhebung, Nutzung
            und Verarbeitung berechtigt sind. Sofern wir von anderen Unternehmen
            personenbezogene Daten von Ihnen erhalten, werden Sie so schnell wie
            möglich, spätestens bei dem ersten Kontakt darüber informiert. Auch
            diese Daten werden nur auf der Grundlage der gesetzlichen
            Vorschriften gespeichert und verarbeitet.
          </p>
          <p>
            <b>Ihre personenbezogenen Daten</b>
            <br />
            Personenbezogene Daten sind alle Informationen, die sich auf eine
            identifizierte oder identifizierbare natürliche Person (im Folgenden
            „betroffene Person“) beziehen. Wir erheben und verarbeiten folgende
            personenbezogene Daten
            <br />
            Namen, Vornamen, Wohnanschrift, Telefonnummer, Geburtsdatum,
            Geschlecht, E-Mail-Adresse
          </p>
          <p>
            Die oben genannten personenbezogenen Daten werden von uns für
            folgende Zwecke verarbeitet:
          </p>
          <ListWrap>
            <List>
              {list.map((item, index) => (
                <ListItem key={index}>{item}</ListItem>
              ))}
            </List>
          </ListWrap>
          <p>
            Die Verarbeitung der personenbezogenen Daten ist zur Erreichung der
            oben genannten Zwecke, einschließlich der Durchführung der
            (vertraglichen) Geschäftsbeziehung mit Ihnen erforderlich.
            Rechtsgrundlage für die Datenverarbeitung ist – so weit nicht
            ausdrücklich abweichend angegeben – Artikel 6 (1) (b) und (f) der
            Datenschutzgrundverordnung oder die Ihre ausdrücklich erteilte
            Einwilligung gem. Artikel 6 (1) (a) der Datenschutzgrundverordnung.
          </p>
          <p>
            Soweit die obigen Daten zu einem anderen als dem ursprünglichen
            Erhebungszweck weiterverarbeitet werden sollen, werden Sie hierüber
            vor der Weiterverarbeitung informiert. Auf diesem Wege haben Sie die
            Möglichkeit, der Verarbeitung Ihrer Daten zu einem anderen Zweck zu
            widersprechen.
          </p>
          <p>
            <b>Weitergabe von Daten</b>
            <br />
            Alle Daten, die Sie uns übermitteln, werden vertraulich behandelt.
            Ihre personenbezogenen Daten werden wir weder an Dritte verkaufen
            noch anderweitig vermarkten.
          </p>
          <p>
            Ihre Daten werden grundsätzlich nicht an Dritten zur Nutzung zur
            Verfügung gestellt, es sei denn, Sie haben hierzu Ihr Einverständnis
            erklärt bzw. wir sind zur Weitergabe dieser Daten gesetzlich
            berechtigt und/oder verpflichtet.
          </p>
          <p>
            Wir übermitteln, soweit dies rechtlich zulässig und erforderlich
            ist, um geltendes Recht einzuhalten oder Rechtsansprüche geltend zu
            machen, auszuüben oder zu verteidigen personenbezogene Daten an
            Gerichte, Steuerbehörden, Aufsichtsbehörden. Wir ergreifen alle
            Maßnahmen, um geeignete und angemessene Garantien zum Schutz Ihrer
            personenbezogenen Daten sicherzustellen.
          </p>
          <p>
            Ihre personenbezogenen Daten leiten wir zu den oben genannten
            Zwecken an folgenden Unternehmen weiter:
          </p>
          <p>
            Versandunternehmen/ logistische Dienstleister,
            Zahlungsdienstleister, Softwaredienstleister, Finanzdienstleister,
            Bankinstitute, Handelsvertreter, Marketing- Event- Agenturen,
            Übersetzungsbüros, Druckerei, Rundfunk, Zeitung, Reisebüro,
            Veranstalter, Reiseunternehmen, öffentliche Stellen wie z.B. das
            Statistische Bundesamt, Hauptzollamt, Handelskammer, Versicherungen,
            Zentralregulierer, Reise- und Transportunternehmen wie z.B. Deutsche
            Bahn, Fluggesellschaften, Reisebusunternehmen
          </p>
          <p>
            <b>Speicherdauer</b>
            <br />
            Soweit bei der Erhebung (z.B. im Rahmen einer
            Einwilligungserklärung) keine ausdrückliche Speicherdauer angegeben
            wird, werden die personenbezogenen Daten gelöscht, soweit diese
            nicht mehr zur Erfüllung des Zweckes der Speicherung erforderlich
            sind, es sei denn gesetzliche Aufbewahrungspflichten (z.B. handels-
            und steuerrechtliche Aufbewahrungspflichten) stehen einer Löschung
            entgegen.
          </p>
          <p>
            <b>Datensicherheit</b>
            <br />
            Wir ergreifen technische und organisatorische Sicherheitsmaßnahmen,
            um Ihre Daten, welche wir in unserem Unternehmen speichern und
            verarbeiten gegen Manipulationen, Verlust der Vertraulichkeit,
            Zerstörung und gegen den Zugriff unberechtigter Personen zu
            schützen. Die Sicherheitsmaßnahmen unseres Unternehmens werden
            entsprechend der technologischen Entwicklung fortlaufend verbessert.
          </p>
          <p>
            <b>
              Betroffenenrechte: Recht auf Auskunft, Berichtigung, Löschung oder
              Einschränkung der Verarbeitung Ihrer personenbezogenen Daten,
              Widerspruchsrecht sowie Recht auf Datenübertragbarkeit
            </b>
            <br />
            Auf Anforderung teilen wir Ihnen schriftlich, entsprechend dem
            geltenden Recht mit, ob und welche personenbezogenen Daten wir in
            unserem Unternehmen speichern. Sind Sie selbst als Nutzer
            registriert, bieten wir Ihnen die Möglichkeit, Ihre Daten selbst
            einzusehen und diese gegebenenfalls zu ändern und zu löschen.
            Sollten trotz der Bemühungen unseres Unternehmens um Datensicherheit
            und Datenrichtigkeit falsche Informationen gespeichert worden sein,
            werden wir diese auf Ihre Anforderung berichtigen.
          </p>
          <p>
            Sie haben auch das Recht, die Einschränkung der Verarbeitung
            personenbezogener Daten durch unser Unternehmen zu verlangen.
            Darüber hinaus können Sie verlangen, dass Sie die Daten, die Sie
            unserem Unternehmen bereitgestellt haben, in einem strukturierten,
            gängigen und maschinenlesbaren Format erhalten. Sie können auch der
            Datenverarbeitung personenbezogener Daten durch unser Unternehmen
            widersprechen.
          </p>
          <p>
            Sie haben ferner das Recht, die Löschung Ihrer personenbezogenen
            Daten zu verlangen, sofern gesetzliche Aufbewahrungsfristen nicht
            entgegenstehen. Wir löschen die Daten, wenn wir sie für den Zweck,
            für den wir diese erhoben und verarbeitet haben, nicht mehr
            benötigen, bzw. wenn Sie Ihre erteilte Einwilligung widerrufen, und
            es besteht keine anderweitige Rechtsgrundlage für die weitere
            Verarbeitung Ihrer Daten. Darüber hinaus löschen wir diese Daten,
            wenn die Verarbeitung aus uns unbekannten Gründen unrechtmäßig
            gewesen ist bzw. Sie gegen die Verarbeitung Widerspruch einlegt
            haben und es bestehen keine vorrangigen berechtigten Interessen für
            die Verarbeitung. Eine Löschung Ihrer Daten erfolgt auch dann, wenn
            wir gesetzlich hierzu verpflichtet sind. Unser Unternehmen hat auch
            technische Maßnahmen implementiert, um alle Empfänger Ihrer Daten
            über Ihr Lösch- bzw. Berichtigungsverlangen in Kenntnis zu setzen.
            Dies gilt nur für den Fall, dass wir diese Daten offengelegt bzw.
            öffentlich gemacht haben. Gelöscht werden sollen alle Links, Kopien
            und Replikationen Ihrer personenbezogenen Daten.
          </p>
          <p>
            Sofern Sie in die Verarbeitung Ihrer personenbezogenen Daten
            eingewilligt haben, steht Ihnen jederzeit das Recht zu, mit Wirkung
            für die Zukunft, die Einwilligung zu widerrufen. Durch den Widerruf
            der Einwilligung wird die Datenverarbeitung für die Vergangenheit
            nicht unrechtmäßig.
          </p>
          <p>
            Die Datenübermittlung an unser Unternehmen erfolgt freiwillig. Diese
            Daten sind jedoch für den weiteren Vertragsabschluss bzw. zur
            Beantwortung Ihrer Anfragen erforderlich. Sofern Sie Ihre Daten
            nicht bekannt geben möchten, kann u.U. der Vertrag nicht zustande
            kommen bzw. Ihre Anfragen nicht beantwortet werden. Die
            Bereitstellung der Daten ist für den Vertragsabschluss erforderlich.
          </p>
          <p>
            Die Kontaktdaten des Datenschutzbeauftragten unseres Unternehmens
            sind:{' '}
            <a href="mailto:datenschutzbeauftragter@erdinger.de">
              datenschutzbeauftragter@erdinger.de
            </a>
          </p>
          <p>
            Sie haben auch das Recht, sich bei der zuständigen Aufsichtsbehörde
            über die Datenverarbeitung durch unser Unternehmen zu beschweren.
          </p>
          <p>Die für unser Unternehmen zuständige Datenschutzbehörde ist:</p>
          <p>
            Landesamt für Datenschutzaufsicht Promenade 27 (Schloss) 91522
            Ansbach, Germany Web:{' '}
            <a href="http://www.lda.bayern.de" target="_blank">
              http://www.lda.bayern.de
            </a>
          </p>
          <p>
            <b>Newsletter; Werbung</b>
            <br />
            Bei der Anmeldung zum Bezug des Newsletters unseres Unternehmens
            werden die von Ihnen angegebenen Daten ausschließlich für diesen
            Zweck verwendet.
          </p>
          <p>
            Für eine wirksame Registrierung werden Name und eine valide
            E-Mail-Adresse benötigt. Um zu überprüfen, dass eine Anmeldung
            tatsächlich durch den Inhaber einer E-Mail-Adresse erfolgt, setzen
            wir das „double-opt-in“ Verfahren ein. Hierzu wird die Bestellung
            des Newsletters, den Versand einer Bestätigungsmail und den Eingang
            der hiermit angeforderten Antwort protokolliert. Die Daten werden
            ausschließlich für den Newsletter-Versand verwendet und nicht an
            Dritte weitergegeben.
          </p>
          <p>
            Ihre Einwilligung zur Speicherung Ihrer Daten und deren Nutzung für
            den Newsletter-Versand können Sie jederzeit widerrufen. In jedem
            Newsletter findet sich dazu entweder ein entsprechender Abmelde-
            Link oder aber eine separate Abmelde- Option.{' '}
          </p>
          <p>
            <b>Daten Minderjähriger</b>
            <br />
            Personenbezogene Daten von Kindern werden nicht wissentlich erhoben,
            ohne ausdrücklich darauf hinzuweisen, dass solche Daten nur mit
            Zustimmung der Eltern übermittelt werden dürfen. Eine Verwendung
            oder Weitergabe der personenbezogenen Daten von Kindern durch unser
            Unternehmen erfolgt nur, soweit dies gesetzlich erlaubt ist, zur
            Einholung der gesetzlich erforderlichen elterlichen Zustimmung oder
            zum Schutz von Kindern. Für den Begriff “Kind/Kinder” sind hier die
            national geltenden gesetzlichen Bestimmungen zu berücksichtigen.
          </p>
          <p>
            <b>Protokolldaten</b>
            <br />
            Wenn Sie auf die Homepage unseres Unternehmens zugreifen,
            übermittelt Ihr Internet-Browser aus technischen Gründen automatisch
            folgende Daten (im Folgenden „Protokolldaten“) an den Webserver
            unseres Unternehmens, die unser Unternehmen in Logfiles erfasst:
          </p>
          <ListWrap>
            <List>
              <ListItem>
                Datum des Zugriffes, Uhrzeit und Verweildauer des Zugriffs, URL
                der verweisenden Webseite, abgerufene Datei, übertragene
                Datenmenge, Browsertyp und –version, Betriebssystem, Domainname
                Ihres Internet-Zugangsanbieters
              </ListItem>
            </List>
          </ListWrap>
          <p>
            Hierbei handelt es sich ausschließlich um Informationen, welche
            keine Rückschlüsse auf die natürliche Person zulassen. Diese
            Informationen sind technisch notwendig, um von Ihnen angeforderte
            Webseite-Inhalte korrekt anzuzeigen und fallen bei Nutzung von
            Internet-Angeboten zwingend an. Die Protokolldaten werden rein zu
            statistischen Zwecken ausgewertet, um den Internetauftritt unseres
            Unternehmens und die dahinterstehende Technik zu optimieren und
            werden im Anschluss gelöscht.
          </p>
          <p>
            Die Protokolldaten werden getrennt von anderen Daten gespeichert,
            die im Rahmen der Nutzung von unserem Unternehmen erhoben werden.
          </p>
          <p>
            <b>
              Welche Daten verarbeiten wir, wenn Sie unsere Webseite besuchen?
            </b>
            <br />
            Wie viele andere Webseiten verwendet unser Unternehmen auch so
            genannte „Cookies“. Cookies sind kleine Textdateien, die von einem
            Webseitenserver auf Ihre Festplatte übertragen werden. Hierdurch
            erhält unser Unternehmen automatisch bestimmte Daten über Ihren
            Besuch auf unserer Webseite. In den von ERDINGER verwendeten Cookies
            werden keine personenbezogenen Daten gespeichert. Die von uns
            verwendeten Cookies sind damit keiner bestimmten Person und damit
            auch nicht Ihnen zuordenbar.
          </p>
          <p>
            Die Website unseres Unternehmens kann grundsätzlich auch ohne
            Cookies besucht werden. Internet-Browser sind regelmäßig so
            eingestellt, dass sie Cookies akzeptieren. Sie können die Verwendung
            von Cookies jederzeit über die Einstellungen Ihres Browsers
            deaktivieren. Bei Deaktivierung der Cookies können möglicherweise
            einzelne Funktionen der Website unseres Unternehmens nicht mehr
            funktionieren. Die meisten von uns verwendeten Cookies werden nach
            Ende der Browser- Sitzung wieder von Ihrer Festplatte gelöscht (sog.
            Session- Cookies). Session Cookies werden dafür benötigt, um Ihnen
            die Login- Informationen über mehrere Seiten hinweg anzubieten.
            Andere (dauerhafte Cookies) verbleiben auf Ihrem Rechner und
            ermöglichen es uns, Ihren Rechner bei Ihrem nächsten Besuch
            wiederzuerkennen und so unserer Webseite und Angebote für Sie
            entsprechend zu gestalten und eine erleichterte Nutzung zu
            ermöglichen.
          </p>
          <p>
            <b>Pseudonimisierte Nutzungsprofile</b>
            <br />
            Zu Zwecken der Werbung, Marktforschung und zur bedarfsgerechten
            Gestaltung sowie zur Verbesserung unserer Dienste erhebt unser
            Unternehmen mit Hilfe von Cookies Nutzungsdaten über Ihren
            Website-Besuch und über die Nutzung von Links im Newsletter. Die
            Erhebung der Nutzungsdaten und die Erstellung eines Nutzungsprofils
            erfolgt pseudonym unter Verwendung einer Cookie-ID.Diese
            Nutzungsprofile erstellt und speichert unser Unternehmen
            ausschließlich in pseudonymer Form. Sie werden nicht mit Ihren
            personenbezogenen Daten zusammengeführt.
          </p>
          <p>
            <b>Wie kann ich Cookies deaktivieren?</b>
            <br />
            Im Folgenden haben wir Links zusammengestellt, unter denen Sie
            detaillierte Informationen zur Deaktivierung von Cookies in gängigen
            Browsern finden:
          </p>
          <ListWrap>
            <List>
              {linkList.map((item, index) => (
                <ListItem key={index}>
                  <a href={item.href} target="_blank">
                    {item.name}
                  </a>
                </ListItem>
              ))}
            </List>
          </ListWrap>
          <p>
            <b>Webanalyse mittels Matomo</b>
            <br />
            Umfang der Verarbeitung personenbezogener Daten: Zur statistischen
            Auswertung nutzen wir auf dieser Website die Open-Source-Software
            „Matomo“ (
            <a href="https://www.matomo.org" target="_blank">
              www.matomo.org
            </a>
            ). Die Software setzt ein Cookie (eine Textdatei) auf ihren Rechner,
            mit dem Ihr Browser wiedererkannt werden kann. Werden Unterseiten
            unserer Webseite aufgerufen, so werden folgende Daten gespeichert:
          </p>
          <ListWrap>
            <List>
              {list2.map((item, index) => (
                <ListItem key={index}>{item}</ListItem>
              ))}
            </List>
          </ListWrap>
          <p>
            Die mit Matomo erhobenen Daten werden auf unseren eigenen Servern
            gespeichert. Eine Weitergabe an Dritte erfolgt nicht.
          </p>
          <iframe
            style={{
              border: 0,
              height: isMobile ? 350 : 200,
              width: '100%',
              margin: -8,
            }}
            src="https://analytics.erdinger.de/index.php?module=CoreAdminHome&action=optOut&language=de&backgroundColor=&fontColor=fff&fontSize=18px&fontFamily='sans-serif'"
          ></iframe>
          <p>
            <b>Rechtsgrundlage</b>
            <br />
            Die Rechtsgrundlage, auf der wir mittels Matomo personenbezogene
            Daten verarbeiten, ist Art. 6 Abs. 1 lit. f der DSGVO.
          </p>
          <p>
            <b>Zweck der Datenverarbeitung</b>
            <br />
            Wir benötigen die Daten, um das Surfverhalten der Nutzer zu
            analysieren und Informationen über Nutzung der einzelnen Komponenten
            der Website zu erhalten. Das ermöglicht uns, die Website und ihre
            Nutzerfreundlichkeit stetig zu optimieren. In diesen Zwecken liegt
            unser berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO
            begründet. Durch die Anonymisierung der IP-Adresse tragen wir dem
            Interesse der Nutzer am Schutz personenbezogener Daten Rechnung. Die
            Daten werden nie dazu genutzt, den Nutzer der Website persönlich zu
            identifizieren und werden nicht mit anderen Daten zusammengeführt.
          </p>
          <p>
            <b>Dauer der Speicherung</b>
            <br />
            Die Daten werden gelöscht, wenn sie für unsere Zwecke nicht mehr
            benötigt werden.
          </p>
          <p>
            <b>Widerspruchsmöglichkeit</b>
            <br />
            Gegen die Aufzeichnung der Daten in der oben beschriebenen Weise
            können Sie auf drei verschiedene Weisen Widerspruch einlegen:
          </p>
          <ListWrap>
            <List>
              {list3.map((item, index) => (
                <ListItem key={index}>{item}</ListItem>
              ))}
            </List>
          </ListWrap>
          <p>
            <b>Google Adwords Conversion Tracking</b>
            <br />
            Wir nutzen das Angebot von Google Adwords, um mit Hilfe von
            Werbemitteln (sog. Google Adwords) auf externen Webseiten auf unsere
            Angebote aufmerksam zu machen. Anhand der Daten der Werbekampagnen
            können wir den Erfolg der Werbemaßnahmen bemessen. Damit können wir
            Ihnen Werbung anzeigen, die für Sie interessant ist und um unsere
            Webseite interessanter zu gestalten.
          </p>
          <p>
            Die Werbemittel werden von Google über „Ad Server“ übermittelt die
            unter Verwendung von Cookies laufen und der Erfolgsbemessung wie
            z.B. Einblendung der Werbemaßnahme und Klicks der Nutzer dienen.
            Sofern Sie über eine Google- Anzeige auf unsere Webseite gelangen,
            so wird von Google ein Cookie auf Ihrem Rechner gespeichert, der in
            der Regel nach 30 Tagen seine Gültigkeit verliert. Eine persönliche
            Identifizierung erfolgt darüber nicht, es kann lediglich eine
            Wiedererkennung Ihres Internetbrowsers erfolgen.
          </p>
          <p>
            Sofern ein Nutzer bestimmte Seiten der Webseite eines Adwords-
            Kunden besucht hat und das auf seinem Computer gespeicherte Cookie
            noch nicht abgelaufen ist, können Google und der Kunden erkennen,
            dass der Nutzer auf die Anzeige geklickt hat und zu dieser Seite
            weitergeleitet wurde. Jedem Adwords- Kunden wird ein anderes Cookie
            zugeordnet. Cookies können somit nicht über die Webseiten des
            Adwords- Kunden nachverfolgt werden. Wir selbst erheben, und
            verarbeiten in den genannten Werbemaßnahmen keine personenbezogenen
            Daten. Wir erhalten von Google lediglich statistische Auswertungen,
            anhand derer wir erkennen welche Werbemittel effektiv sind. Eine
            Identifizierung der Nutzer kann dadurch nicht erfolgen.
          </p>
          <p>
            Aufgrund des eingesetzten Marketing- Tools baut Ihr Browser
            automatisch eine direkte Verbindung mit dem Server von Google auf.
            Wir haben keinen Einfluss auf den Umfang und die weitere Verwendung
            der Daten, die durch den Einsatz dieses Tools durch Google erhoben
            werden und informieren Sie daher entsprechend unserem Kenntnisstand:
            Durch die Einbindung von AdWords Conversion erhält Google die
            Information, dass Sie den entsprechenden Teil unseres
            Internetauftritts aufgerufen oder eine Anzeige von uns angeklickt
            haben. Sofern Sie bei einem Dienst von Google registriert sind, kann
            Google den Besuch Ihrem Account zuordnen. Selbst wenn Sie nicht bei
            Google registriert sind bzw. sich nicht eingeloggt haben, besteht
            die Möglichkeit, dass der Anbieter Ihre IP-Adresse in Erfahrung
            bringt und speichert.
          </p>
          <p>
            Sie können die Teilnahme an diesem Tracking- Verfahren auf
            verschiedene Weise verhindern: Z.B indem Sie Ihre Browser- Software
            so einstellen, sodass Cookies unterdrückt werden oder durch
            Deaktivierung der Cookies für Conversion Tracking sodass Cookies von
            der Domain „
            <a href="https://ads.google.com" target="_blank">
              www.googleadservices.com
            </a>
            " blockiert werden,{' '}
            <a href="https://www.google.de/settings/ads" target="_blank">
              https://www.google.de/settings/ads
            </a>
            . Durch Deaktivierung der interessenbezogenen Anzeigen der Anbieter,
            die Teil der Selbstregulierungskampagne „About Ads“ sind, über{' '}
            <a href="https://optout.aboutads.info" target="_blank">
              https://optout.aboutads.info
            </a>{' '}
            oder aber durch dauerhafte Deaktivierung in Ihren Browsern Firefox,
            Internet explorer oder Chrome &#40;
            <a href="http://www.google.com/settings/ads/plugin" target="_blank">
              http://www.google.com/settings/ads/plugin
            </a>
            &#41;. Wir weisen darauf hin, dass Sie in diesem Fall u.U. nicht
            alle Funktionen dieses Angebots vollumfänglich nutzen können.
          </p>
          <p>
            <b>Links zu anderen Webseiten</b>
            <br />
            Sofern ERDINGER Weißbräu direkt oder indirekt auf fremde
            Internetseiten verweist ("Links"), haftet ERDINGER Weißbräu nur,
            wenn sie von den Inhalten genaue Kenntnis hat und es ihr technisch
            möglich und zumutbar ist, die Nutzung im Falle rechtswidriger
            Inhalte zu verhindern.
          </p>
          <p>
            ERDINGER Weißbräu erklärt hiermit ausdrücklich, dass zum Zeitpunkt
            der Linksetzung die verlinkten Seiten keine illegalen Inhalte
            enthalten haben. ERDINGER Weißbräu hat keinerlei Einfluss auf die
            aktuelle und zukünftige Gestaltung der verlinkten Seiten. ERDINGER
            Weißbräu distanziert sich daher hiermit ausdrücklich von allen
            inhaltlichen Änderungen, die nach der Linksetzung auf den verlinkten
            Seiten vorgenommen werden. Dies gilt auch für Fremdeinträge in die
            von ERDINGER Weißbräu eingerichteten Gästebücher, Diskussionsforen
            und Mailinglisten.
          </p>
          <p>
            Die Werner Brombach GmbH ist nicht verantwortlich für den Inhalt,
            die Verfügbarkeit, die Richtigkeit und die Genauigkeit der
            verlinkten Seiten, deren Angebote, Links oder Werbeanzeigen.
            ERDINGER Weißbräu haftet nicht für illegale, fehlerhafte oder
            unvollständige Inhalte und insbesondere für Schäden, die durch
            Nutzung oder Nichtnutzung der auf den verlinkten Seiten angebotenen
            Informationen entstehen.
          </p>
          <p>
            <b>Youtube</b>
            <br />
            Das Unternehmen verwendet die Videoplattform YouTube, welche von
            YouTube LLC, 901 Cherry Ave. San Bruno, CA 94066 in USA betrieben
            wird.
            <br />
            <br />
            YouTube ist eine Plattform, durch die die Wiedergabe von Audio- und
            Videodateien ermöglicht wird. Wenn der Kunde eine Seite des
            Internetauftritts des Unternehmens aufruft, stellt der dort
            eingebundene Player von YouTube eine Verbindung zu YouTube her, um
            die technische Übertragung des Videos bzw. der Audiodatei
            sicherzustellen. Bei der Herstellung der Verbindung zu YouTube
            werden Daten an YouTube übertragen.
            <br />
            <br />
            Zweck und Umfang der Datenerhebung, der weiteren Verarbeitung und
            Nutzung der Daten durch YouTube sowie die diesbezüglichen Rechte und
            Einstellungsmöglichkeiten zum Schutz der Privatsphäre des Kunden
            kann der Kunde den Datenschutzhinweisen von YouTube entnehmen.
            <br />{' '}
            <a
              href="https://support.google.com/youtube/answer/2801895?hl=de"
              target="_blank"
              rel="noreferrer noopener"
            >
              https://support.google.com/youtube/answer/2801895?hl=de
            </a>{' '}
          </p>
          <p>
            <b>Sonstiges</b>
            <br />
            Die Privatbrauerei ERDINGER Weißbräu Werner Brombach GmbH hat
            jederzeit das Recht, diese Datenschutzerklärung unter Beachtung der
            geltenden gesetzlichen Datenschutzbestimmungen zu ändern. Beauftragt
            ERDINGER Weißbräu für die Durchführung von bestimmten
            Dienstleistungen Partnerfirmen, so werden in den Verträgen mit den
            Partnern die Datenschutzbestimmungen übertragen und die Partner auf
            die Einhaltung des Datenschutzes verpflichtet. Wir kümmern uns um
            die Einhaltung der Datenschutzbestimmungen in allen Bereichen
            unserer Plattform und unseres Unternehmens. Wenn Sie Fragen haben,
            können Sie sich auch direkt an uns wenden.
          </p>
        </div>
      </Section>
      <Footer stickyVisible={false} />
    </>
  )
}

export default IndexPage
